import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Box } from "@material-ui/core";
import MenuDebitsManager from "../../components/MenuDebitsManager";
import LoadingDefault from "../../components/LoadingDefault";
import ContentNotLoaded from "../../components/ContentNotLoaded";
import { errorDefault } from "../../helper/errorDefault";
import ActionAcquirer from "../../components/ActionAcquirers";
import TableAcquirers from "../../components/TableAcquirers";
import {
  editAcquirer,
  getAcquirers
} from "../../helper/Acquirers";
import Alert from '../../components/Alert';

const styles = () => ({
  container: {
    padding: "0px 30px 20px 30px",
    marginTop: "130px",
  },
  menuGroup: {
    display: "flex",
    width: "100%",
    marginTop: "10px",
    marginBottom: "30px",
    padding: "20px 0px 0px 0px",
  },
  menuIcon: {
    width: 30,
    marginRight: 7,
  },
  linkGroup: {
    textDecoration: "none",
  },
  button: {
    color: "rgb(24, 116, 185)",
    fontSize: 17,
    background: "none",
    border: "none",
    boxShadow: "none",
  },
  loadingDiv: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  marginBottom: {
    marginBottom: 40,
  },
});

export class ListAcquirers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingAcquirer: false,
      errorLoading: false,
      errorMessage: "",
      snackBarMessage: "",
      AcquirerList: [],
      filteredAcquirerList: [],
      ListAcquirerFiltered: [],
      acquirer: null,
      severity: "info"
    };
  }

  componentDidMount() {
    this.getAcquirerList();
  }

  async getAcquirerList() {
    this.setState({
      loadingAcquirer: true,
      errorMessage: "",
      errorLoading: false,
      filteredAcquirerList: [],
      ListAcquirerFiltered: [],
    });

    const filter = {
      numeroPagina: 0,
      itensPorPagina: 100,
      nomeFantasia: null,
      inscricao: null,
      exigePreCadastro: null,
      possuiCheckoutInterno: null,
      possuiCheckoutExterno: null,
      ativo: null,
      sigla: null,
      campoOrdenacao: null,
      sentidoOrdenacao: null,
    };

    try {
      let lstAcquirers = await getAcquirers(filter);

      this.setState({
        AcquirerList: lstAcquirers,
        filteredAcquirerList: lstAcquirers,
        loadingAcquirer: false,
      });
    } catch (error) {
      let errorMessage = errorDefault(error);

      this.setState({
        errorMessage: errorMessage,
        errorLoading: true,
        loadingAcquirer: false,
      });
    }
  }

  editAcquirer = (acquirer) => {
    this.setState({
      acquirer: acquirer,
    });
  };

  getAcquirerFiltered = (filterParams) => {
    let filteredList = this.state.AcquirerList;
    if (
      filterParams.nomeFantasia !== null ||
      filterParams.cnpj !== null ||
      filterParams.interno !== null ||
      filterParams.externo !== null ||
      filterParams.status !== null ||
      filterParams.precadastro !== null ||
      filterParams.sigla !== null
    ) {
      if (filterParams.nomeFantasia !== null)
        filteredList = filteredList.filter((x) =>
          x.NomeFantasia.includes(filterParams.nomeFantasia)
        );
      if (filterParams.cnpj && filterParams.cnpj !== null)
        filteredList = filteredList.filter(
          (x) => String(x.Inscricao) === filterParams.cnpj
        );
      if (filterParams.interno !== null)
        filteredList = filteredList.filter(
          (x) => x.PossuiCheckoutInterno === filterParams.interno
        );
      if (filterParams.externo !== null)
        filteredList = filteredList.filter(
          (x) => x.PossuiCheckoutExterno === filterParams.externo
        );
      if (filterParams.status !== null)
      {
        filteredList = filteredList.filter(
          (x) => x.Ativo === filterParams.status
          );
        }
      if (filterParams.sigla !== null)
        filteredList = filteredList.filter((x) =>
          x.Sigla.includes(filterParams.sigla.trim())
        );
      if (filterParams.precadastro && filterParams.precadastro !== null)
        filteredList = filteredList.filter(
          (x) => x.ExigePreCadastro === filterParams.precadastro
        );
    }
    this.setFilteredAcquirerList(filteredList);
  };

  setFilteredAcquirerList(ListAcquirer) {
    this.setState({
      filteredAcquirerList: ListAcquirer,
      ListAcquirerFiltered: ListAcquirer,
    });
  }

  cancelAcquirer = () => {
    this.setState({
      acquirer: null,
    });
  };

  sendEditAcquirer = async (acquirer) => {
    const NewAcquirer = {
      Id: acquirer.id,
      NomeFantasia: acquirer.nomeFantasia,
      Inscricao: acquirer.cnpj,
      ExigePreCadastro: acquirer.precadastro,
      Logotipo: acquirer.logo,
      PossuiCheckoutInterno: acquirer.externo,
      PossuiCheckoutExterno: acquirer.interno,
      Ativo: acquirer.status,
      Sigla: acquirer.sigla,
    };

    this.setState({
      loadingAcquirer: true,
    });

    await editAcquirer(NewAcquirer)
      .then((response) => {
        if (response.data.Erros.length > 0) {
          var menssage = "";
          response.data.Erros.map((x) => (menssage += x.Mensagem + " \n"));

          this.setState({
            snackBarMessage: menssage,
            openSnackValue: true,
            severity: "error"
          });
        } else {
          this.setState({
            snackBarMessage: "Adquirente atualizado com sucesso!",
            openSnackValue: true,
            acquirer: null,
            severity: "success"
          });
        }
      })
      .catch((error) => {
        this.setState({
          snackBarMessage: "Error ao gravar o Adquirentes",
          openSnackValue: true,
          severity: "error"
        });
      });

    this.setState({
      loadingAcquirer: false,
      acquirer: null,
    });

    this.getAcquirerList();
  };

  togleSnackbar = (value) => {
    this.setState({ openSnackValue: value});
  }

  render() {
    const { classes } = this.props;
    const {
      snackBarMessage,
      loadingAcquirer,
      errorLoading,
      errorMessage,
      openSnackValue,
      acquirer,
      severity
    } = this.state;

    return (
      <div>
        <Grid container className={classes.container}>
          <MenuDebitsManager />

          <Box width={1}>
            <ActionAcquirer
              filtraData={this.getAcquirerFiltered}
              actionEdit={this.sendEditAcquirer}
              acquirerEdit={acquirer}
              cancelAcquirer={this.cancelAcquirer}
            />
          </Box>

          {loadingAcquirer && (
            <div className={classes.loadingDiv}>
              <LoadingDefault typeLoading={"card"} />
            </div>
          )}

          <Alert
            open={openSnackValue}
            Close={this.togleSnackbar}
            message={snackBarMessage}
            severity={severity}
          />

          {errorLoading && <ContentNotLoaded message={errorMessage} />}

          {this.state.filteredAcquirerList.length > 0 && (
            <Box width={1}>
              <TableAcquirers
                tableData={this.state.filteredAcquirerList}
                tableFilter={this.state.ListAcquirerFiltered}
                navigateToEdit={this.editAcquirer}
              />
            </Box>
          )}
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ListAcquirers);
